
import { Component, Vue } from "vue-property-decorator";
import { SMAdditionalInfo, SMCases } from "@/store";
import CandidateServicesTable from "@/modules/Services/Components/Table/CandidateServicesTable.vue";
import { RouteRecord } from "vue-router";

const SERVICES_BASE_PATH = "cases";
const CANDIDATE_SERVICE_BASE_PATH = "CandidateService";
const DASHBOAAR_TAB_TYPE = "dashboard";

const ICONS = {
  plus: "add-outline",
};

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    CandidateServicesTable,
  },
})
export default class Browse extends Vue {
  services = [];

  async beforeRouteEnter(to: any, from: any, next: any) {
    const matched = from.matched.find(
      (x: { name: string } | RouteRecord) => x.name === CANDIDATE_SERVICE_BASE_PATH
    );

    if (matched) return next({ params: { id: null } });

    await SMCases.getTableCases();

    const services: any = SMCases.casesCandidate;

    let tab_type = DASHBOAAR_TAB_TYPE;
    let tab_type_id = 0;

    if (SMCases.caseLayoutTabs?.length) {
      const firstTab = SMCases.caseLayoutTabs.reduce((minItem, currentItem) => {
        return currentItem.index < minItem.index ? currentItem : minItem;
      });

      if (firstTab) {
        tab_type = firstTab.tab_type;
        tab_type_id = firstTab.tab_type_id;
      }
    }

    if (services.length === 1)
      return next(`/${SERVICES_BASE_PATH}/${services[0].ID}/${tab_type}/${tab_type_id}`);

    next(async (vm: any) => {
      if (services?.length) vm.services = services;

      await vm.getDependantsList();
    });
  }

  // When we return, data not reloaded. because that we should re-fetch data. Strange "router" behavior.
  async activated() {
    await SMCases.getTableCases();

    this.services = SMCases.casesCandidate;

    // await this.getDependantsList();

    this.$forceUpdate();
  }

  get serviceWithEnableStartDependantsVisa() {
    return this.services?.find((service) => service.can_start_dependant_case);
  }

  dependantVisaEnable = false;

  get isDependantVisaStartEnable() {
    return this.services?.some((service) => service.can_start_dependant_case);
  }

  get dependentVisaButtonProps() {
    return {
      iconLeft: ICONS.plus,
    };
  }

  get dependantsList() {
    return SMAdditionalInfo.dependantsList;
  }

  mounted() {
    SMAdditionalInfo.fetchDependantsList();
  }

  getDependentVisa() {
    SMAdditionalInfo.buySWDependantVisa();
  }
}
